import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  standalone: true,
  name: 'unixToDatetime',
  pure: false,
})
export class UnixToDatetimePipe implements PipeTransform {
  private translateService = inject(TranslocoService);

  transform(value: number, ...args: unknown[]): string {
    const date = new Date(value * 1000);
    let h = date.getHours();
    const m = date.getMinutes();
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();
    //TODO Prüfen welches Land 12h-Format bzw. 24h-Format hat und ggf. Label anpassen und übersetzen
    if (this.translateService.getActiveLang() === 'de-DE') {
      return (
        `${dd < 10 ? '0' + dd : dd}.${mm < 10 ? '0' + mm : mm}.${yyyy}` +
        ' um ' +
        `${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}` +
        ' Uhr'
      );
    } else {
      h = h % 12;
      h = h ? h : 12;
      const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
      return (
        `${mm}/${dd}/${yyyy}` + ' | ' + `${h}:${m < 10 ? '0' + m : m}` + ampm
      );
    }
  }
}
